export const IS_LOADING = 'IS_LOADING'
export const FINISHED_LOADING = 'FINISHED_LOADING'
export const RESET_LOADING = 'RESET_LOADING'

export const EXCEPTION_TYPE_NETWORK = 'network'
export const EXCEPTION_TYPE_ERROR = 'error'

export const RESET_TYPE_INCLUDE_SUB_KEYS = 'RESET-INCLUDE-SUB-KEYS'
export const LOADING_SHOW_MODAL_SPINNER = 'LOADING_SHOW_MODAL_SPINNER'

export function isLoading(name){
	return {
		type: IS_LOADING,
		name: name
	}
}

export function finishedLoading(name, error){
	let type = null

	if(error){
		if(error.name == 'FetchError'){
			type = 	EXCEPTION_TYPE_NETWORK
		}else{
			switch((error || {}).message){
				case 'Network request failed':
					type = EXCEPTION_TYPE_NETWORK
					break

				default:
					type = EXCEPTION_TYPE_ERROR
			}
		}
	}

	return {
		type: FINISHED_LOADING,
		name: name,
		error: typeof(error) === 'object' && 'message' in error ? error.message : error,
		errorCode: typeof(error) === 'object' && 'code' in error ? error.code : error,
		exceptionType: type
	}
}

export function resetLoading(name, type){
	return {
		type: RESET_LOADING,
		name: name,
		resetType: type
	}
}

/**
 * Wrapper around loading/finished loading for promises, returns a thunk
 * to test a method using this, you'll need to use the createDispatchMock method
 * @param action
 * @param promise
 * @returns (function(){})
 */
export function thunk(action, prom){
	return (dispatch) => promise(dispatch, action, prom)
}

/**
 * Wrapper around loading/finished loading for promises, returns a thunk
 * @param dispatch
 * @param action
 * @param prom
 * @returns {Promise.<T>|Promise<T>}
 */
export function promise(dispatch, action, prom){
	dispatch(isLoading(action))
	return prom
		.then((ret) => {
			dispatch(finishedLoading(action))
			return ret
		})
		.catch(
			(e) => {
				dispatch(finishedLoading(action, e))

				// Rethrow the exception otherwise other .catch handlers will fail
				if(e){
					throw e
				}
			}
		)
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/actions/loading.js